export default {"src":"/_next/static/media/api-deck-logo.412f4382.svg","height":23,"width":95,"blurWidth":0,"blurHeight":0};